import { getBranchId, getHospitalId } from "../../../auth"
import FetchData from "../../client"

export const GetHsnCode = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_gethsncode", inputData)
        return result
    } catch (error) {
        console.error("Error in fetching HSN code:", error);
        throw error;
    }
}
export const AddHsnCode = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_addhsncode", inputData)
        return result
    } catch (error) {
        console.error("Error in adding HSN code:", error);
        throw error;
    }
}

export const UpdateHsnCode = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_updatehsncode", inputData)
        return result
    } catch (error) {
        console.error("Error in updating HSN code:", error);
        throw error;
    }
}

export const DeleteHsnCode = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_deletehsncode", inputData)
        return result
    } catch (error) {
        console.error("Error in deleting HSN code:", error);
        throw error;
    }
}